const breakpointsApp = {
	desktop: 1080,
	tabletLand: 992,
	tablet: 768,
	mobile: 0,
};

const sliderOptions = {
	default: {
		speed: 400,
		direction: document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr',
	},
	'js-slider-last-reviews-yotpo': {
		type: 'slide',
		pagination: true,
		arrows: true,
		perMove: 3,
		perPage: 3,
		gap: 40,
		breakpoints: {
			1080: {
				arrows: false,
				perPage: 1,
				perMove: 1,
			},
		},
	},
	'js-slider-announcement-bar': {
		type: 'loop',
		autoplay: true,
		pauseOnHover: true,
		pauseOnFocus: true,
		pagination: false,
		arrows: false,
		interval: 3000,
		perMove: 1,
		perPage: 1,
	},
	'js-slider-hero': {
		type: 'loop',
		rewind: true,
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
	},
	'js-slider-certification': {
		type: 'loop',
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		slideFocus: true,
		padding: '30%',
		fixedWidth: '150px',
		mediaQuery: 'min',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-reassurance': {
		type: 'loop',
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		padding: '28%',
		gap: 20,
		slideFocus: true,
		mediaQuery: 'min',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-awards': {
		type: 'slide',
		pagination: true,
		arrows: false,
		perMove: 6,
		perPage: 6,
		gap: 40,
		breakpoints: {
			1080: {
				perMove: 1,
				perPage: 1,
				padding: '20%',
				fixedWidth: '80%',
			},
		},
	},
	'js-slider-articles': {
		type: 'loop',
		rewind: true,
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		focusableNodes: 'button, textarea, input, select, iframe',
		mediaQuery: 'min',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-main-product': {
		type: 'slide',
		destroy: false,
		pagination: true,
		arrows: true,
		perMove: 1,
		perPage: 1,
	},
	'js-slider-list-product': {
		type: 'slide',
		pagination: false,
		arrows: true,
		perMove: 3,
		perPage: 3,
		center: true,
		gap: '12px',
		breakpoints: {
			1080: {
				padding: '20%',
				perPage: 1,
				perMove: 1,
			},
		},
	},
	'js-slider-product-recommendations-mini-cart': {
		type: 'slide',
		destroy: false,
		pagination: false,
		arrows: true,
		perMove: 3,
		perPage: 3,
		center: true,
		gap: '12px',
		breakpoints: {
			1080: {
				fixedWidth: '75%',
				perPage: 1,
				perMove: 1,
			},
		},
	},
	'js-slider-product-recommendations-cart': {
		type: 'slide',
		destroy: false,
		pagination: false,
		arrows: true,
		perMove: 3,
		perPage: 3,
		gap: '12px',
		breakpoints: {
			1080: {
				fixedWidth: '75%',
				perPage: 1,
				perMove: 1,
			},
		},
	},
	'js-slider-product-howtouseit': {
		type: 'slide',
		mediaQuery: 'min',
		destroy: false,
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		fixedWidth: '233px',
		gap: '20px',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-cart-drawer-side': {
		type: 'slide',
		mediaQuery: 'min',
		destroy: false,
		pagination: true,
		arrows: false, // can be true if needed, check on ClrzSliderNoDefer.js file
		perMove: 1,
		perPage: 1,
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-cart-gift-wrap': {
		type: 'slide',
		mediaQuery: 'min',
		destroy: false,
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,

		breakpoints: {
			1080: {
				destroy: false,
			},
		},
	},
	'js-slider-list-pushs': {
		type: 'loop',
		pagination: false,
		arrows: true,
		perMove: 1,
		perPage: 4,
		gap: '12px',
		fixedWidth: '260px',
		padding: '15%',
		destroy: false,
		breakpoints: {
			1080: {
				perPage: 1,
				padding: 0,
				fixedWidth: '100%',
				destroy: false,
				pagination: true,
			},
		},
	},
	'js-slider-timeline': {
		type: 'loop',
		pagination: false,
		arrows: false,
		perMove: 1,
		perPage: 2,
		gap: '110px',
		fixedWidth: '344px',
		padding: '30%',
		speed: 300,
		updateOnMove: true,
		easing: 'linear',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-ingredients': {
		type: 'loop',
		pagination: false,
		arrows: true,
		perMove: 1,
		perPage: 4,
		gap: '12px',
		fixedWidth: '260px',
		padding: '15%',
		destroy: false,
		breakpoints: {
			1080: {
				perPage: 1,
				padding: 0,
				fixedWidth: '100%',
				destroy: false,
				pagination: true,
			},
		},
	},
	'js-slider-only-mobile': {
		type: 'loop',
		pagination: true,
		arrows: true,
		perMove: 1,
		perPage: 1,
		mediaQuery: 'min',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-pushs-icons-text': {
		type: 'loop',
		pagination: true,
		arrows: true,
		perMove: 2,
		perPage: 2,
		gap: 20,
		mediaQuery: 'min',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-icons': {
		type: 'slide',
		mediaQuery: 'min',
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		gap: '30px',
		fixedWidth: '82%',
		padding: {left: '28px', right: '28px'},
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-stats': {
		type: 'loop',
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		padding: '20%',
		gap: '12px',
		mediaQuery: 'min',
		breakpoints: {
			1080: {
				destroy: true,
			},
		},
	},
	'js-slider-bundle-header': {
		type: 'slide',
		pagination: true,
		arrows: false,
		perMove: 1,
		perPage: 1,
		center: true,
		gap: '12px',
		destroy: true,
		breakpoints: {
			1080: {
				destroy: false,
			},
		},
	},
	'js-slider-cart-sample': {
		type: 'loop',
		rewind: true,
		pagination: true,
		arrows: true,
		perMove: 1,
		perPage: 2,
		focus: 'center',
		gap: '12px',
		destroy: true,
		breakpoints: {
			992: {
				destroy: false,
			},
		},
	},
};

export {sliderOptions, breakpointsApp};
